import React, { ReactElement } from 'react'
import { Text } from '@mindfulchefuk/design-system'
import { flex } from 'styled-system/patterns'
import { OnboardingChooseRecipesBanner } from '@mindfulchefuk/onboarding/components/OnboardingChooseRecipes/OnboardingChooseRecipesBanner/OnboardingChooseRecipesBanner'
import { CMSBanner } from '@mindfulchefuk/features/CMS/interfaces'
import { TOTAL_RECIPES_AVAILABLE_PER_WEEK } from '@mindfulchefuk/constants'

export type TOnboardingChooseRecipesHeader = {
  minimumRecipes: number
  maximumRecipes: number
  banner: CMSBanner | null
}

export const OnboardingChooseRecipesHeader = ({
  minimumRecipes,
  maximumRecipes,
  banner,
}: TOnboardingChooseRecipesHeader): ReactElement => {
  return (
    <>
      <div className={flex({ direction: 'column' })}>
        <Text
          variant={{ base: 'heading-md', sm: 'heading-lg' }}
          as="h1"
          id="choose-recipes-heading"
          mb={16}
          color="aubergine"
        >
          Choose {minimumRecipes} to {maximumRecipes} delicious healthy recipes
        </Text>
        <Text
          variant="body-lg"
          as="h2"
          id="choose-recipes-subheading"
          mb={16}
          color="aubergine"
        >
          From {TOTAL_RECIPES_AVAILABLE_PER_WEEK} recipes to pick from, changing
          every week. Skip a week or cancel at any time.
        </Text>
      </div>

      <OnboardingChooseRecipesBanner banner={banner} />
    </>
  )
}
